// Client-side mirror of sb-express-app's src/utils/PasswordPolicy.js (spec 10):
// min 8 characters, at least one letter and one digit. Deliberately no
// special-character / mixed-case rule — see that file for why. This is the
// one place in this repo that encodes the rule, so every password-entry
// surface validates against the same wording the backend enforces.

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_POLICY_MESSAGE =
  `Password must be at least ${PASSWORD_MIN_LENGTH} characters and include at least one letter and one digit.`;

// Returns the first policy violation as a user-facing message, or null when
// the password is compliant.
export function validatePassword(password: string): string | null {
  if (typeof password !== 'string' || password.length < PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters`;
  }
  if (!/[0-9]/.test(password)) {
    return 'Password must contain a digit';
  }
  if (!/[A-Za-z]/.test(password)) {
    return 'Password must contain a letter';
  }
  return null;
}

export function isValidPassword(password: string): boolean {
  return validatePassword(password) === null;
}
